export const AssetSortKey = {
    Date: 'date',
    Name: 'name',
} as const

export type AssetSortKey = (typeof AssetSortKey)[keyof typeof AssetSortKey]

export const DEFAULT_ASSET_SORT: AssetSortKey = AssetSortKey.Date

export const ASSET_SORT_KEYS: AssetSortKey[] = Object.values(AssetSortKey)
